<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="foodinfo" :rules="rules" ref="foodrule" label-width="120px" class="">
			<el-row>
				<el-col :span="8">
					<el-form-item label="餐类型" prop="categoryid">
					    <el-select style="width: 100%;" v-model="foodinfo.categoryid" placeholder="请选择餐类型">
							<el-option v-for="item in category" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					    </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="所属档口" prop="stallid">
					    <el-select style="width: 100%;" v-model="foodinfo.stallid" placeholder="请选择档口">
							<el-option v-for="item in stalls" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					    </el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="菜品名称" prop="name">
						<el-input clearable v-model="foodinfo.name"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="菜品简称" prop="nikename">
						<el-input clearable v-model="foodinfo.nikename"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="规格" prop="spec">
						<el-input clearable v-model="foodinfo.spec"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="单位" prop="unit">
						<el-input clearable v-model="foodinfo.unit"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="售价" prop="price" >
						<el-input-number style="width: 100%;" v-model="foodinfo.price" :precision="2" :min="0.1" :max="200" label="售价"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="优惠价" prop="offprice">
						<el-input-number style="width: 100%;" v-model="foodinfo.offprice" :precision="2" :min="0" :max="200" label="优惠价"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="打包费" prop="packprice" >
						<el-input-number style="width: 100%;" v-model="foodinfo.packprice" :precision="2" :min="0" :max="5" label="打包费"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<el-form-item label="重量" prop="weight">
						<el-input-number style="width: 100%;" v-model="foodinfo.weight" :precision="2" :min="0" :max="1000" label="重量"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="每日最大售卖" prop="perdaymax">
						<el-input-number style="width: 100%;" v-model="foodinfo.perdaymax" :precision="0" :min="0" :max="1000" label="每日最大售卖"></el-input-number>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="排序" prop="index">
						<el-input-number style="width: 100%;" v-model="foodinfo.index" :precision="2" :min="0" :max="1000" label="排序"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-form-item label="菜品描述" prop="description">
						<el-input type="textarea" :rows="3" placeholder="请输入菜品描述" clearable v-model="foodinfo.description"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item label="菜品大图" >
						<el-upload :action="fileuploadUrl" :data="filetype" :file-list="bigPicture"
							:before-upload="(file) => handleBeforeUpload(file,'big') "
							list-type="picture-card" :limit="1" :multiple="false" :on-error="handleUploadError"
							:on-preview="handlePictureCardPreview" :headers="uploadheader"
							:on-remove="(file, fileList) => handleRemove(file, fileList,'big')" 
							:on-exceed="(file, fileList) => handleExceed(file, fileList,'big')"
							:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList, 'big')">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="菜品中图" >
						<el-upload :action="fileuploadUrl" :data="filetype" :file-list="midPicture"
							:before-upload="(file) => handleBeforeUpload(file,'middle') "
							list-type="picture-card" :limit="1" :multiple="false" :on-error="handleUploadError"
							:on-preview="handlePictureCardPreview" :headers="uploadheader"
							:on-remove="(file, fileList) => handleRemove(file, fileList,'middle')" 
							:on-exceed="(file, fileList) => handleExceed(file, fileList,'middle')"
							:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList, 'middle')">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>	
			<el-row>
				<el-col :span="12">
					<el-form-item label="菜品小图" >
						<el-upload :action="fileuploadUrl" :data="filetype" :file-list="smallPicture"
							:before-upload="(file) => handleBeforeUpload(file,'small') "
							list-type="picture-card" :limit="1" :multiple="false" :on-error="handleUploadError"
							:on-preview="handlePictureCardPreview" :headers="uploadheader"
							:on-remove="(file, fileList) => handleRemove(file, fileList,'small')" 
							:on-exceed="(file, fileList) => handleExceed(file, fileList,'small')"
							:on-success="(response, file, fileList) => handleUploadSucc(response, file, fileList, 'small')">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</el-col>
			</el-row>	
		</el-form>
		<el-dialog :modal="true" :append-to-body="true" :modal-append-to-body="false" :visible.sync="pictureVisible">
			<img width="100%" :src="pictureImageUrl" alt="">
		</el-dialog>
		<div style="text-align: center;">
			<el-button type="primary" @click="saveFoods">保存</el-button>
		</div>
	</div>
</template>

<script> 
	import { nfsprefix, baseUrl,prefix } from '/static/baseUrl.js'
	import { queryFoodDetail,deleteFoodPicture,addNewFood, editFood } from '/static/apiUrl.js'
	export default {
		name : 'FoodsDetail',
		data() {
			return {
				editok : false,
				pictureVisible : false,
				pictureImageUrl : '',
				uploadheader : {
					Authorization: sessionStorage.getItem("authToken")
				},
				fileuploadUrl : baseUrl+prefix+'/api/business/foodfile/upload',
				filetype: {
					type: "",
				},
				foodinfo : {
					"id": "",
					"name": "",
					"nikename": "",
					"categoryid": "",
					"stallid": "",
					"ownbusinessid": "",
					"price": 0,
					"offprice": 0,
					"packprice": 0,
					"platformprice": 0,
					"platformoffprice": 0,
					"discount": 0,
					"index": 0,
					"description": "",
					"spec": "",
					"unit": "",
					"perdaymax": 0,
					"state": "",
					"weight": 0
				},
				bigPicture : [],
				midPicture : [],
				smallPicture : [],
				rules:{
					name: [
						{ required: true, message: '请输入菜品名称', trigger: 'blur' }
					],
					categoryid :[
						{ required: true, message: '请选择菜品分类', trigger: 'blur' }
					],
					stallid: [
						{ required: true, message: '请选择所属档口', trigger: 'blur' }
					],
					price : [
						{ required: true, message: '请输入售价', trigger: 'blur'},
						{ type: 'number', min: 0.1, max: 200, message: '售价在0.1~200之间', trigger: ['change','blur'] }
					],
					description : [
						{ required: true, message: '请输入菜品描述', trigger: 'blur' }
					],
					spec: [
						{ required: true, message: '请输入菜品规格', trigger: 'blur' }
					],
					unit: [
						{ required: true, message: '请输入菜品单位', trigger: 'blur' }
					],
					perdaymax: [
						{ required: true, message: '请输入菜品每日最大售卖量', trigger: 'blur' },
						{ type: 'number', min: 0, max: 1000, message: '每日最大售卖量在0~1000之间', trigger: ['change','blur'] }
					],
				}
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			fid : {
				type: String,
				required: false
			},
			category : {
				type : Array,
				required : true
			},
			stalls : {
				type : Array,
				required : true
			}
		},
		watch: {
			fid: {
				immediate: true,
				handler(newVal) {
					console.log(newVal)
					this.clearData()
					this.foodDetail(newVal)
				}
			},
		},
		methods: {
			clearData(){
				this.foodinfo = {
					"id": "",
					"name": "",
					"nikename": "",
					"categoryid": "",
					"stallid": "",
					"ownbusinessid": "",
					"price": 0,
					"offprice": 0,
					"packprice": 0,
					"platformprice": 0,
					"platformoffprice": 0,
					"discount": 0,
					"index": 0,
					"description": "",
					"spec": "",
					"unit": "",
					"perdaymax": 0,
					"state": "",
					"weight": 0,
				}
				this.bigPicture = []
				this.midPicture = []
				this.smallPicture = []
				this.pictureImageUrl = ''
				this.editok = false
			},
			foodDetail(foodid){
				if(foodid !== undefined && foodid !== null && foodid != ''){
					queryFoodDetail({id : foodid}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.foodinfo = res.data
							if(res.data.service_images && res.data.service_images.length > 0){
								res.data.service_images.forEach((item) => {
									if("big" == item.foodspicture_type){
										this.bigPicture.push({
											id : item.foodspicture_id,
											name : item.foodspicture_name,
											url :  baseUrl+nfsprefix +item.foodspicture_fileurl,
											size : 0,
											status : 'success',
											uid : item.foodspicture_id,
										})
									}else if("small" == item.foodspicture_type){
										this.smallPicture.push({
											id : item.foodspicture_id,
											name : item.foodspicture_name,
											url :  baseUrl+nfsprefix +item.foodspicture_fileurl,
											size : 0
										})
									}else{
										this.midPicture.push({
											id : item.foodspicture_id,
											name : item.foodspicture_name,
											url :  baseUrl+nfsprefix +item.foodspicture_fileurl,
											size : 0
										})
									}
								})
							}
						}
					})
				}
			},
			handleRemove(file, fileList,type) {
				console.log(file, fileList);
				let fid = ''
				if('big' == type){
					fid = this.bigPicture[0].id
				}else if('small' == type){
					fid = this.smallPicture[0].id
				}else{
					fid = this.midPicture[0].id
				}
				deleteFoodPicture({ids : [fid]}).then(res => {
					if(0 == res.code){
						if('big' == type){
							this.bigPicture.splice(0,1)
						}else if('small' == type){
							this.smallPicture.splice(0,1)
						}else{
							this.midPicture.splice(0,1)
						}
					}
				})
			},
			handlePictureCardPreview(file) {
				this.pictureImageUrl = file.url
				this.pictureVisible = true
			},
			handleUploadSucc(response, file, fileList,type){
				console.log(response,file,fileList)
				if(0 == response.code){
					if('big' == type){
						this.bigPicture.push({
							id : response.data,
							name : file.name,
							url : file.url,
							size : file.size
						})
					}else if('small' == type){
						this.smallPicture.push({
							id : response.data,
							name : file.name,
							url : file.url,
							size : file.size
						})
					}else{
						this.midPicture.push({
							id : response.data,
							name : file.name,
							url : file.url,
							size : file.size
						})
					}
				}else{
					this.$message.error("上传失败")
				}
			},
			handleUploadError(err, file, fileList){
				console.log(err,file,fileList)
			},
			handleExceed(file, fileList, type){
				if('big' == type && this.bigPicture.length >0){
					this.$message.warning("只能上传一张图片")
				}else if('small' == type && this.smallPicture.length >0){
					this.$message.warning("只能上传一张图片")
				}else{
					if(this.midPicture.length >0){
						this.$message.warning("只能上传一张图片")
					}
				}
			},
			handleBeforeUpload(file,type){
				let types = [
					"image/jpeg",
					"image/jpg",
					"image/png"
				];
				const isImage = types.includes(file.type);
				const isLtSize = file.size / 1024 / 1024 < 1;
				if (!isImage) {
					this.$message.warning("上传图片只能是 JPG、JPEG、PNG 格式!");
					return false;
				}
				if (!isLtSize) {
					this.$message.warning("上传图片大小不能超过 1MB!");
					return false;
				}
				this.filetype.type = type
				return file
			},
			saveFoods(){
				this.$refs["foodrule"].validate((valid) => {
					if (valid) {
						let fileids = []
						if(this.bigPicture.length > 0){
							fileids.push(this.bigPicture[0].id)
						}
						if(this.midPicture.length > 0){
							fileids.push(this.midPicture[0].id)
						}
						if(this.smallPicture.length > 0){
							fileids.push(this.smallPicture[0].id)
						}
						this.foodinfo.fileids = fileids
						if(this.foodinfo.id != null && this.foodinfo.id != ''){  //编辑
							editFood(this.foodinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true)
									this.$message.success("修改菜品信息成功")
								}else{
									this.$emit("needRefrash",false)
									this.$message.error(res.msg)
								}
							})
						}else{ //新增
							addNewFood(this.foodinfo).then(res => {
								console.log(res)
								if(0 == res.code){
									//this.editok = true
									this.$emit("needRefrash",true)
									this.$message.success("添加菜品信息成功")
								}else{
									this.$emit("needRefrash",false)
									this.$message.error(res.msg)
								}
							})
						}
					} else {
						return false;
					}
				});
			},
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>